<template>
  <div>
    <q-table
      flat
      dense
      virtual-scroll      
      hide-pagination
      :no-data-label="$t('erro.semDados')"
      row-key="TCM_CODIGO"
      :rows="filteredData"
      :rows-per-page-options="[0]"
      :fullscreen="isFullscreen" 
      :columns="table_columns"
      :style="isFullscreen ? 'width: 100%; height: 100%;' : ''"
      class="dass-sticky-header-table dass-table-border"
      style="overflow-x: auto;"
      @virtual-scroll="onTableScroll"
    >
      <template v-slot:top>
        <div class="col-12 flex justify-between">
          <h3>{{ $t('dass.discountCoupons') }}</h3>
          <q-btn
            dense
            flat
            icon="mdi-fullscreen"            
            id="dass-btn-fullscreen"
            @click="() => {
              this.isFullscreen = !this.isFullscreen
            }"
          />
        </div>
        <div v-if="selectedFilters.length > 0" class="col-12 flex justify-between">
          <div  class="col-3">
            <span style="color: blue">{{`Filtros selecionados` + ': ' + this.selectedFilters.length}}</span>
            <q-btn              
              dense
              tooltip="Limpar filtros"
              color="blue"
              icon="mdi-filter-remove-outline"
              :class="`q-ml-md q-mr-sm dass-color-button-wallet-table-${brandName}`"
              @click="clearFilterColumn"
            />
          </div>
          <div class="col-6 flex q-gutter-md">             
            <q-input
              v-if="isFilterStatus"
              type="date"
              dense
              debounce="400"
              label="Protocolo"
              v-model="tcc_status"
              @keyup.enter="loadFilter('TCC_STATUS')"
            >
              <template v-slot:append>
                <q-btn  :loading="this.isLoadingFilter" @click="loadFilter('TCC_STATUS')" round dense flat icon="mdi-magnify" :class="`dass-color-button-wallet-table-${brandName}`"/>
                <q-btn  @click="clearFilter" round dense flat icon="mdi-magnify-remove-outline" :class="`dass-color-button-wallet-table-${brandName}`"/>
              </template>
            </q-input>
            <q-btn-dropdown
              v-if="isFilterStatus"              
              style="background-color: var(--color-fila-primary); color: white;"
              dropdown-icon="mdi-filter-menu-outline"
              :class="`q-ml-md q-mr-sm dass-color-button-wallet-table-${brandName}`"
            >
              <q-list>
                <q-item clickable v-close-popup @click="onItemClick('TCC_STATUS')">
                  <q-item-section>
                    <q-item-label>Status</q-item-label>
                  </q-item-section>
                </q-item>      
              </q-list>
            </q-btn-dropdown>
          </div>
        </div>

      </template>
      <template v-slot:header-cell="props">
        <q-th class="dass-th-header" :class="{'dass-th-padding': !this.isRotated[props.col.field]}" :props="props">
          {{props.col.label}} 
           <div v-if="props.col.field == 'selected'">
            <q-checkbox dense v-model="valueCheckAll" @click="onCheckAll"/>
            <q-tooltip
              anchor="top middle"
              self="bottom middle"
              :label="!valueCheckAll ? $t('dassCheckAll') : $t('dassUncheckAll')"
            />
          </div>         
          <q-btn
            v-if="props.col.field !== 'selected'"
            icon="mdi-filter-menu-outline"
            :dense="true"
            size="0.6rem"
             :class="{ 'dass-rotated-button': this.isRotated[props.col.field],  'dass-rotated-button-back': !this.isRotated[props.col.field]}, `dass-color-button-wallet-table-${brandName}`"
            class="q-ml-md q-mr-sm dass-color-button-wallet-table"
            @click="toggleSelectFilter(props.col.field)"
          >
          </q-btn>
          <div v-show="showSelectFilter[props.col.field]" class="dass-filter-select q-ma-xs">
            <q-select
              v-model="filters[props.col.field]"
              :options="getUniqueOptions(props.col.field)"
              :label="props.col.label"
              :class="`dass-select-filter-table-${brandName}`"
              dense
              outlined
              multiple
              cleareble
              emit-value
              map-options
              hide-selected
              @update:model-value="selectFilter"
            >
              <template  #option="scope">
                <div class="column q-pr-sm" v-bind="scope.itemProps">
                  <q-item-section>
                    <q-checkbox
                      :model-value="scope.selected"
                      @update:model-value="scope.toggleOption(scope.opt)"
                    >
                      {{ scope.label}}
                    </q-checkbox>
                  </q-item-section>
                </div>
              </template>
            </q-select>
          </div>
        </q-th>
      </template>
      <template v-slot:body="props">
        <q-tr>          
          <q-td key="TCM_CODIGO" class="dass-font-body-table dass-cell-value text-left">
            <q-btn dense flat icon="mdi-content-copy" class="dass-button-copy" color="blue" @click="copyContent(props.row.TCM_CODIGO, props.pageIndex)" />
            {{ props.row.TCM_CODIGO }}
            <div :class="`dass-subtext-content-copy-${props.pageIndex}`"></div>
          </q-td>
          <q-td key="TIC_CAMPANHA" class="dass-font-body-table dass-cell-value text-center">{{ props.row.TIC_CAMPANHA }}</q-td>
          <q-td key="TIC_DESCONTO" :style="props.row.TIC_DESCONTO > 0 ? 'color: blue;' : ''" class="dass-font-body-table dass-cell-value text-center">{{ props.row?.TIC_DESCONTO  > 0 ? `${props.row.TIC_DESCONTO}%` : ''  }}</q-td>
          <q-td key="TCM_DTVALIDADE" class="dass-font-body-table dass-cell-value text-center">{{ props.row.TCM_DTVALIDADE }}</q-td>
          <q-td key="TCC_STATUS" class="dass-font-body-table dass-cell-value text-center">{{ props.row.TCC_STATUS }}</q-td>
          <q-td key="PED_DTSIS" class="dass-font-body-table dass-cell-value text-center">{{ props.row.PED_DTSIS }}</q-td>                            
          <q-td key="PED_NUMCLI" class="dass-font-body-table dass-cell-value text-center">{{ props.row.PED_NUMCLI }}</q-td>
        </q-tr>        
      </template>
    </q-table>
    <div v-if="dataTable.length <= 0 && isFiltered">
      <div class="dass-no-users-found">
        <div>
          <span style="width: 100%; margin-top: 10px;">
            {{$t('dassNoRecordsFoundOnThisPage')}}
          </span>
        </div>
        <div>
          <span style="width: 100%; margin-top: 10px;">
            {{$t('dassTryUsingAdvancedFiltersToDoAFullDatabaseSearch')}}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import { useIsSafari } from '@/composables/useIsSafari'
export default {
  name: 'CouponsTransactions',
  setup() {
    const { isSafari, brandName } = useIsSafari()    
    return {      
      isSafari,
      brandName
    }     
  },
  data() {
    return {
      current_list: [],      
      selectedFilters: [],
      CON_ID: 0,
      tcc_status: '',
      isLoadingExport: false,
      searchOrder: '',
      isFilterStatus: false,
      isFilterDateRequestedIn: false,
      isFullscreen: false,
      searchProtocol: '',
      isLoadingFilter: false,
      isRotated: {},
      showSelectFilter: {},
      filters: {
        TCM_CODIGO: [],
        TIC_CAMPANHA: [],
        TIC_DESCONTO: [],
        TCM_DTVALIDADE: [],
        TCC_STATUS: [],
        PED_DTSIS: [],
        PED_NUMCLI: [],
      }
    }
  },
  methods: {
    ...mapActions('wallet', ['getDiscountCoupons']),
    ...mapActions('create_protocol', ['loadDataConsumer',]),
    getUniqueOptions(field) {
      return  [... new Set(this.filteredData.map(row => row[field]))]      
    },
    async loadConId() {
      if (!this.getDataConsumer?.length) {
        await this.loadDataConsumer()
      }
    },
    async loadFilter(field) {
      const filter = field?.toLowerCase() || ''
      if(!filter) return
      const filterValue = this[field.toLowerCase()]
      this.isLoadingFilter = true
      await this.getDiscountCoupons({ con_id: this.CON_ID, [filter]: filterValue })
      this.isLoadingFilter = false
    },
    copyContent(content, index) {
      navigator.clipboard.writeText(content)
        .then(() => {
          const subMessage = document.getElementsByClassName('dass-subtext-content-copy-' + index)
          let smallElement = subMessage[0].querySelector('small')
          if (!smallElement) {
            smallElement = document.createElement('small')
            subMessage[0].appendChild(smallElement)
          }
          smallElement.innerText = 'Copiado com sucesso!'
          smallElement.style.color = 'green'
          setTimeout(() => {
            subMessage[0].removeChild(smallElement)
          }, 8000)
        })
        .catch((err) => {
          const subMessage = document.getElementsByClassName('dass-subtext-content-copy')
          let smallElement = subMessage[0].querySelector('small')
          if (!smallElement) {
            smallElement = document.createElement('small')
            subMessage[0].appendChild(smallElement)
          }
          smallElement.innerText = `Erro ao copiar: ${err}`
          smallElement.style.color = 'red'
          setTimeout(() => {
            subMessage[0].removeChild(smallElement)
          }, 8000)
        })
    },
    toggleSelectFilter(columnField) {
      this.isRotated[columnField] = !this.isRotated[columnField]
      this.showSelectFilter[columnField] = !this.showSelectFilter[columnField]
    },
    selectFilter(val) {
      if(val.length > 0) {
        this.selectedFilters.push(val)
      } else if(this.selectedFilters.length > 0 && val.length == 0) {
        this.selectedFilters.pop()
      }
    },
    clearFilter() {
      for (const prop in this.filters) {
        this.filters[prop] = []
      }
      this.isRotated = []
      this.showSelectFilter = []
      this.selectedFilters = []
      this.isLoadingFilter = false
      this.tcc_status = ''     
    },
    clearFilterColumn() {
      for (const prop in this.filters) {
        this.filters[prop] = []
      }
      this.isRotated = []
      this.showSelectFilter = []
      this.selectedFilters = []
    },
    moveSortIcons() {
      const headers = document.querySelectorAll('.dass-th-header')
      headers.forEach((header) => {
        const sortIcon = header.querySelector('.q-table__sort-icon')
        const dassSelect = header.querySelector('.dass-filter-select')

        if (sortIcon && dassSelect) {
          header.insertBefore(sortIcon, dassSelect)
        }
      })
    },
    onItemClick(isShowInputName) {
      this.isFilterStatus =  !this.isFilterStatus
    }
  },
  computed: {
    ...mapGetters('create_protocol', ['getDataConsumer']),
    ...mapGetters('wallet', {
      dataTable: 'getDiscountCoupons',
    }), 
    filteredData() {
      return this.dataTable.filter(row => {
        return Object.keys(this.filters).every(key => {
          if(this.filters[key].length === 0) return true
          return this.filters[key].includes(row[key])
        })
      })
    },
    table_columns: function () {
      return [
        {
          name: 'TCM_CODIGO',
          align: 'center',
          label: 'Cupom',
          field: 'TCM_CODIGO',
          sortable: true,
          classes: 'dass-cell-table',         
          headerClasses: `dass-header-table dass-header-table-${this.brandName}`
        },
        {
          name: 'TIC_CAMPANHA',
          align: 'center',
          label: 'Campanha',
          field: 'TIC_CAMPANHA',
          sortable: true,
          classes: 'dass-cell-table',         
          headerClasses: `dass-header-table dass-header-table-${this.brandName}`
        },
        {
          name: 'TIC_DESCONTO',
          align: 'center',
          label: 'Desconto',  
          field: 'TIC_DESCONTO',
          sortable: true,
          classes: 'dass-cell-table',         
          headerClasses: `dass-header-table dass-header-table-${this.brandName}`
        },
        {
          name: 'TCM_DTVALIDADE',
          align: 'center',
          label: 'Validade',
          field: 'TCM_DTVALIDADE',
          sortable: true,
          classes: 'dass-cell-table',         
          headerClasses: `dass-header-table dass-header-table-${this.brandName}`
        },
        {
          name: 'TCC_STATUS',
          align: 'center',
          label: 'Status',
          field: 'TCC_STATUS',          
          sortable: true,
          classes: 'dass-cell-table',         
          headerClasses: `dass-header-table dass-header-table-${this.brandName}`
        },
        {
          name: 'PED_DTSIS',
          align: 'center',
          label: 'Utilizado em',
          field: 'PED_DTSIS',
          sortable: true,
          classes: 'dass-cell-table',         
          headerClasses: `dass-header-table dass-header-table-${this.brandName}`
        },
        {
          name: 'PED_NUMCLI',
          align: 'center',
          label: 'Pedido',
          field: 'PED_NUMCLI',
          sortable: true,
          classes: 'dass-cell-table',         
          headerClasses: `dass-header-table dass-header-table-${this.brandName}`
        },  
      ]
    },    
  }, 
  async mounted() {
    this.moveSortIcons()
    await this.loadConId()
    this.CON_ID = this.getDataConsumer[0]?.CON_ID 
  }

}

</script>

<style lang="scss">
.dass-cell-value {
  width: auto;
  white-space: nowrap
}
#dass-btn-fullscreen {
  position: absolute;
  top: 0.2rem;
  right: 0.2rem;  
}
thead tr {
  background-color: var(--color-default-new-balance) !important;
  color: white;
  font-weight: 700;
  height: 48px !important;   
}
.dass-div-loading {
  width: 100%;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dass-select-filter-table-umbro {
  background-color: white !important; 
  border-radius: var(--border-radius-card);
  color: var(--theme-white);
}
.dass-select-filter-table-newbalance {
  background-color: white !important; 
  border-radius: var(--border-radius-card);
  color: var(--theme-white);
}
.dass-select-filter-table-fila {
    background-color: white;
    border-color: white;
    border-radius: var(--border-radius-card);
    color: var(--color-fila-secondary);
}
.dass-header-table-umbro {
  font-family: Inter, sans-serif !important;
  text-transform: uppercase !important;
  color: white;
  background-color: var(--color-default-umbro) !important;
}
.dass-header-table-fila {
  font-family: Inter, sans-serif !important;
  text-transform: uppercase !important;
  color: white;
  background-color: var(--color-fila-secondary) !important;
}
.dass-header-table-newbalance {
  font-family: Inter, sans-serif !important;
  text-transform: uppercase !important;
  color: white !important;
  background-color: var(--color-default-new-balance) !important;
}
.dass-color-button-wallet-table-umbro {
  color: var(--theme-white) !important;
  background-color: var(--color-default-umbro) !important;
  border-radius: var(--border-radius-button-umbro) !important;  
}
.dass-color-button-wallet-table-fila {
  color: var(--theme-white) !important;
  background-color: var(--color-fila-primary) !important;
  border-radius: var(--border-radius-button-fila) !important; 
  padding-left: 0.7rem !important;
  padding-right: 0.7rem !important;
}
.dass-color-button-wallet-table-newbalance {
  color: var(--theme-white) !important;
  background-color: var(--color-default-new-balance) !important;
  border-radius: var(--border-radius-button-newbalance) !important; 
}
.dass-no-users-found {
  width: 100%;
  margin-top: 15vh;
  margin-bottom: 15vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  justify-items: center;
}
.dass-font-header-table {  
  font-size: 18px !important;
}
.dass-font-body-table { 
  font-size: 18px !important;
}
.dass-sticky-header-table {
  height: calc(100vh - 45vh);
  @media(max-width: 700px) {
    height: calc(100vh - 40vh);
  }  
  thead tr th {
    position: sticky;
    z-index: 1;
  }
  thead tr:first-child th {
    top: 0;
  }
  &.q-table--loading thead tr:last-child th {
    top: 48px;
  }
  tbody {
    scroll-margin-top: 48px;
  }
  .dass-rotated-button {
    transform: rotate(180deg);
    transition: transform 0.3s ease-in-out;
  }
  .dass-rotated-button-back {
    transform: rotate(0deg);
    transition: transform 0.3s ease-in-out;
  }
  .dass-th-padding {
    padding: var(--space) 0 var(--space) 0;
  }
}
</style>